import api from './api';

export const diaryService = {
  async getAllEntries(params = {}) {
    const response = await api.get('/diary/all', { params });
    return response.data;
  },

  async getEntryById(id, isEditMode = false) {
  const headers = {};
  if (isEditMode) {
    headers['x-edit-mode'] = 'true';
  }
  
  const response = await api.get(`/diary/${id}`, { headers });
  return response.data.data;
},

  async createEntry(entryData) {
    const response = await api.post('/diary/create', entryData);
    return response.data.data;
  },

  async updateEntry(id, entryData) {
    const response = await api.put(`/diary/${id}`, entryData);
    return response.data.data;
  },

  async deleteEntry(id) {
    const response = await api.delete(`/diary/${id}`);
    return response.data;
  },

  async searchEntries(params = {}) {
    const response = await api.get('/diary/search', { params });
    return response.data;
  },

  async getFolders() {
    const response = await api.get('/diary/folders');
    return response.data.data;
  },

  async getTags() {
    const response = await api.get('/diary/tags');
    return response.data.data;
  },

  async getStats() {
    const response = await api.get('/diary/stats');
    return response.data.data;
  },
};
